/**
 * Configuration helpers for company CDD section components
 */

import { RiskLevel, VerificationStatus } from "../../../../types/cdd-records.types";

export const getRiskBadgeClass = (risk: RiskLevel): string => {
	switch (risk) {
		case "low":
			return "bg-gradient-to-r from-emerald-100 to-green-100 text-emerald-800 border-emerald-200 shadow-sm";
		case "medium":
			return "bg-gradient-to-r from-amber-100 to-yellow-100 text-amber-800 border-amber-200 shadow-sm";
		case "high":
			return "bg-gradient-to-r from-orange-100 to-red-100 text-orange-800 border-orange-200 shadow-sm";
		case "critical":
			return "bg-gradient-to-r from-rose-100 to-red-100 text-rose-800 border-rose-200 shadow-sm";
		default:
			return "bg-gradient-to-r from-slate-100 to-gray-100 text-slate-700 border-slate-200 shadow-sm";
	}
};

export const getVerificationBadgeClass = (status: VerificationStatus): string => {
	switch (status) {
		case "verified":
			return "bg-gradient-to-r from-emerald-100 to-green-100 text-emerald-800 shadow-sm";
		case "pending":
			return "bg-gradient-to-r from-amber-100 to-yellow-100 text-amber-800 shadow-sm";
		case "failed":
			return "bg-gradient-to-r from-rose-100 to-red-100 text-rose-800 shadow-sm";
		case "expired":
			return "bg-gradient-to-r from-orange-100 to-amber-100 text-orange-800 shadow-sm";
		case "not-started":
			return "bg-gradient-to-r from-slate-100 to-gray-100 text-slate-700 shadow-sm";
		default:
			return "bg-gradient-to-r from-slate-100 to-gray-100 text-slate-700 shadow-sm";
	}
};
